/* globals ga */
import debounce from 'lodash/debounce';
import formClear from '@PROJECT_ROOT/assets/desktop/js/search/formClear';
import { showResultCount } from '@PROJECT_ROOT/assets/desktop/js/search/searchResultCount';
import slider from '@PROJECT_ROOT/assets/shared/js/rangeSlider';

let priceSlider = null;

const filter = {

    $accommodationType: null,
    $airConditioning: null,
    $arrival: null,
    $beachDistance: null,
    $beachType: null,
    $bedrooms: null,
    $category: null,
    $departure: null,
    $discounts: null,
    $inet: null,
    $persons: null,
    $land: null,
    $latitude: null,
    $location: null,
    $location_id: null,
    $longitude: null,
    $nearMe: null,
    $outerViewSea: null,
    $parking: null,
    $petsAllowed: null,
    $pool: null,
    $priceFrom: null,
    $priceTo: null,
    init(options) {
        const self = this;
        const $filterForm = $('#filterForm');

        self.$accommodationType = $(`#${options.formIds.accommodationType}`);
        self.$airConditioning = $(`#${options.formIds.airConditioning}`);
        self.$arrival = $(`#${options.formIds.arrival}`);
        self.$beachDistance = $(`#${options.formIds.beachDistance}`);
        self.$beachType = $(`#${options.formIds.beachType}`);
        self.$bedrooms = $(`#${options.formIds.bedrooms}`);
        self.$category = $(`#${options.formIds.category}`);
        self.$departure = $(`#${options.formIds.departure}`);
        self.$discounts = $(`#${options.formIds.discounts}`);
        self.$land = $(`#${options.formIds.land}`);
        self.$latitude = $(`#${options.formIds.latitude}`);
        self.$location = $(`#${options.formIds.location}`);
        self.$location_id = $(`#${options.formIds.location_id}`);
        self.$longitude = $(`#${options.formIds.longitude}`);
        self.$nearMe = $(`#${options.formIds.nearMe}`);
        self.$outerViewSea = $(`#${options.formIds.outerViewSea}`);
        self.$parking = $(`#${options.formIds.parking}`);
        self.$persons = $(`#${options.formIds.persons}`);
        self.$distribution = $(`#${options.formIds.distribution}`);
        self.$petsAllowed = $(`#${options.formIds.petsAllowed}`);
        self.$pool = $(`#${options.formIds.pool}`);
        self.$moor = $(`#${options.formIds.moor}`);
        self.$food = $(`#${options.formIds.food}`);
        self.$priceFrom = $(`#${options.formIds.priceFrom}`);
        self.$priceTo = $(`#${options.formIds.priceTo}`);
        self.$wifi = $(`#${options.formIds.wifi}`);
        self.$neLat = $(`#${options.formIds.nelat}`);
        self.$neLng = $(`#${options.formIds.nelng}`);
        self.$swLat = $(`#${options.formIds.swlat}`);
        self.$swLng = $(`#${options.formIds.swlng}`);
        self.$radius = $(`#${options.formIds.radius}`);
        self.$deviation = $(`#${options.formIds.deviation}`);
        self.populateForm();

        $('#resetFilter').click(() => {
            const ignoredFilterSelectors = [
                `#${self.$arrival.attr('id')}`,
                `#${self.$departure.attr('id')}`,
                `#${self.$deviation.attr('id')}`,
                `#${self.$location.attr('id')}`,
                `#${self.$location_id.attr('id')}`,
                `#${self.$latitude.attr('id')}`,
                `#${self.$longitude.attr('id')}`,
                `#${self.$nearMe.attr('id')}`,
                `#${self.$persons.attr('id')}`,
                `#${self.$distribution.attr('id')}`,
                `#${self.$neLat.attr('id')}`,
                `#${self.$neLng.attr('id')}`,
                `#${self.$swLat.attr('id')}`,
                `#${self.$swLng.attr('id')}`,
                `#${self.$radius.attr('id')}`,
            ];

            $('.accommodationType').removeClass('has');
            $('.feature').removeClass('active');
            $('.bedrooms').removeClass('has');
            $('.beachDistance').removeClass('has');
            $('.beachType').removeClass('has');
            priceSlider.clear();
            priceSlider.setValues(0, 200);

            formClear('filterForm', ignoredFilterSelectors);
            showResultCountHelper(options.resultsCountUrl);
        });
        const maximalPriceFormField = document.getElementById('filter_form_prc_max');
        const maximalPriceUIHolder = document.getElementById('hotelMaxPrice');
        const minimalPriceFormField = document.getElementById('filter_form_prc_min');
        const minimalPriceUIHolder = document.getElementById('hotelMinPrice');
        // TODO: priceRangeSliderElement zakomentirano zbog lintera(ne koristi se).
        // const priceRangeSliderElement = document.getElementById('priceRangeSlider');

        priceSlider = slider({
            elementId: 'priceRangeSlider',
            initialMin: minimalPriceFormField.value ? minimalPriceFormField.value : 0,
            initialMax: maximalPriceFormField.value ? maximalPriceFormField.value : 200,
            onUpdateCallback: (minimalSelectedPrice, maximalSelectedPrice) => {
                if (maximalSelectedPrice >= 200) {
                    maximalPriceUIHolder.innerText = '200+';
                    maximalPriceFormField.value = 0;
                } else {
                    maximalPriceUIHolder.innerText = maximalSelectedPrice;
                    maximalPriceFormField.value = maximalSelectedPrice;
                }
                minimalPriceUIHolder.innerText = minimalSelectedPrice;
                minimalPriceFormField.value = minimalSelectedPrice;
            },
        });

        $filterForm.on('submit', (e) => {
            e.preventDefault();
            $('#pageLoader').show();
            ga('send', 'event', 'Filteri', 'Traži', getDestination());
            self.setPriceValues();

            const ajaxData = $filterForm.serialize();
            $.get(options.searchResultsURL, ajaxData).then((response) => {
                window.location.href = response.searchResultsURL;
            }, () => {
                $('#pageLoader').hide();
            });
        });

        function getDestination() {
            const destinationElement = document.querySelector('.js-destination');
            if (destinationElement !== null) {
                return destinationElement.textContent;
            }

            return '';
        }

        // Odabir vrste smještaja
        $filterForm.on('click', '.accommodationType', function setAccommodationTypeValue(e) {
            e.stopPropagation();
            e.preventDefault();
            const accommodationType = $(this);
            accommodationType.toggleClass('has');
            self.$accommodationType
                .val(getAccommodationTypeValue())
                .change();
        });

        // Odabir broja spavaćih soba
        $filterForm.on('click', '.bedrooms', function setBedroomsValue(e) {
            e.stopPropagation();
            e.preventDefault();
            const bedrooms = $(this);
            $('.bedrooms').removeClass('has');

            // Ako je korisnik kliknuo na isti botun 'isključi ga'
            if (self.$bedrooms.val().toString() === bedrooms.data('bedrooms').toString()) {
                self.$bedrooms.val('');
            } else {
                self.$bedrooms.val(bedrooms.data('bedrooms'));
                bedrooms.addClass('has');
            }

            self.$bedrooms.change();
        });

        // Odabir udaljenosti od plaže
        $filterForm.on('click', '.beachDistance', function setBeachDistanceValue(e) {
            e.preventDefault();
            e.stopPropagation();
            const beachDistance = $(this);
            $('.beachDistance').removeClass('has');

            // Ako je korisnik kliknuo na isti botun 'isključi ga'
            if (self.$beachDistance.val().toString() === beachDistance.data('beachdistance').toString()) {
                self.$beachDistance.val('');
            } else {
                self.$beachDistance.val(beachDistance.data('beachdistance'));
                beachDistance.addClass('has');
            }

            self.$beachDistance.change();
        });

        // Odabir vrste plaže vrsta plaže
        $filterForm.on('click', '.beachType', function setBeachTypeValue(e) {
            e.preventDefault();
            e.stopPropagation();
            const beachType = $(this);
            $('.beachType').removeClass('has');

            // Ako je korisnik kliknuo na isti botun 'isključi ga'
            if (self.$beachType.val().toString() === beachType.data('beachtype').toString()) {
                self.$beachType.val('');
            } else {
                self.$beachType.val(beachType.data('beachtype'));
                beachType.addClass('has');
            }

            self.$beachType.change();
        });

        // Dodatne usluge WiFi
        $filterForm.on('click', '#wifi', function toggleWifiValue() {
            const wifi = $(this);
            wifi.toggleClass('active');

            if (wifi.hasClass('active')) {
                self.$wifi.val('1');
            } else {
                self.$wifi.val('');
            }

            self.$wifi.change();
        });

        // Dodatne usluge klimatizacija
        $filterForm.on('click', '#airCon', function toggleAirConditioningValue() {
            const airCon = $(this);
            airCon.toggleClass('active');

            if (airCon.hasClass('active')) {
                self.$airConditioning.val('1');
            } else {
                self.$airConditioning.val('');
            }

            self.$airConditioning.change();
        });

        // Dodatne usluge kućni ljubimci
        $filterForm.on('click', '#pets', function togglePetsValue() {
            const pets = $(this);
            pets.toggleClass('active');

            if (pets.hasClass('active')) {
                self.$petsAllowed.val('1');
            } else {
                self.$petsAllowed.val('');
            }

            self.$petsAllowed.change();
        });

        // Dodatne usluge pogled na more
        $filterForm.on('click', '#seaView', function toggleSeaViewValue() {
            const seaView = $(this);
            seaView.toggleClass('active');

            if (seaView.hasClass('active')) {
                self.$outerViewSea.val('1');
            } else {
                self.$outerViewSea.val('');
            }

            self.$outerViewSea.change();
        });

        // Dodatne usluge parking
        $filterForm.on('click', '#privateParking', function toggleParkingValue() {
            const parking = $(this);
            parking.toggleClass('active');

            if (parking.hasClass('active')) {
                self.$parking.val('1');
            } else {
                self.$parking.val('');
            }

            self.$parking.change();
        });

        // Dodatne usluge bazen
        $filterForm.on('click', '#pool', function togglePoolValue() {
            const pool = $(this);
            pool.toggleClass('active');

            if (pool.hasClass('active')) {
                self.$pool.val('1');
            } else {
                self.$pool.val('');
            }

            self.$pool.change();
        });

        // Dodatne usluge vez za čamac
        $filterForm.on('click', '#moor', function toggleMoorValue() {
            const moor = $(this);
            moor.toggleClass('active');

            if (moor.hasClass('active')) {
                self.$moor.val('1');
            } else {
                self.$moor.val('');
            }

            self.$moor.change();
        });

        // Doručak
        $filterForm.on('click', '#food', function toggleFoodValue() {
            const food = $(this);
            food.toggleClass('active');

            if (food.hasClass('active')) {
                self.$food.val('1');
            } else {
                self.$food.val('');
            }

            self.$food.change();
        });

        // Odabir kategorije svi popusti
        $filterForm.on('change', '#allDiscount', function toggleAllDiscountValue() {
            const $allDiscount = $(this);
            const discountValues = self.$discounts.val().length ? self.$discounts.val().split('|') : [];

            if ($allDiscount.prop('checked')) {
                if (discountValues.indexOf($allDiscount.val()) === -1) {
                    discountValues.push($allDiscount.val());
                }
            } else {
                const valueIndex = discountValues.indexOf($allDiscount.val());
                if (valueIndex !== -1) {
                    discountValues.splice(valueIndex, 1);
                }
            }

            self.$discounts.val(discountValues.join('|'));
        });

        // Odabir kategorije 'robinson i luxury'
        $filterForm.on('change', '.category', function toggleCategoryValue() {
            const $changedCategory = $(this);
            const categoryValues = self.$category.val().length ? self.$category.val().split(',') : [];

            if ($changedCategory.prop('checked')) {
                if (categoryValues.indexOf($changedCategory.val()) === -1) {
                    categoryValues.push($changedCategory.val());
                }
            } else {
                const valueIndex = categoryValues.indexOf($changedCategory.val());
                if (valueIndex !== -1) {
                    categoryValues.splice(valueIndex, 1);
                }
            }

            self.$category.val(categoryValues.join(','));
        });

        // Odabir kategorije 'otok ili kopno'
        $filterForm.on('change', '.land', function toggleCategoryValue() {
            const $changedLand = $(this);
            const landValues = self.$land.val().length ? self.$land.val().split('|') : [];

            if ($changedLand.prop('checked')) {
                if (landValues.indexOf($changedLand.val()) === -1) {
                    landValues.push($changedLand.val());
                }
            } else {
                const changedLandValues = $changedLand.val().length ? $changedLand.val().split('|') : [];
                changedLandValues.forEach((changedLandValue) => {
                    const valueIndex = landValues.indexOf(changedLandValue);

                    if (valueIndex !== -1) {
                        landValues.splice(valueIndex, 1);
                    }
                });
            }

            self.$land.val(landValues.join('|'));
        });

        initTotalResultCount(options.resultsCountUrl);
    },
    populateForm() {
        const self = this;

        // Označavanje vrste smještaja
        if (self.$accommodationType.val().length) {
            const values = self.$accommodationType.val().split('|');

            $('.accommodationType').each((index, element) => {
                const $accommodationTypeElement = $(element);
                const elementValues = $accommodationTypeElement.data('value').split('|');

                elementValues.forEach((elementValue) => {
                    if (values.indexOf(elementValue) !== -1) {
                        $accommodationTypeElement.addClass('has');
                    }
                });
            });
        }

        // Označavanje svih popusta
        if (self.$discounts.val().length) {
            const values = self.$discounts.val().split('|');
            const $allDiscount = $('#allDiscount');

            if (values.indexOf($allDiscount.val()) !== -1) {
                $allDiscount.prop('checked', true);
            }
        }

        // Označavanje kategorije smještaja
        if (self.$category.val().length) {
            const values = self.$category.val().split(',');

            $('.category').each((index, element) => {
                const $categoryElement = $(element);
                const elementValues = $categoryElement.val().split(',');

                elementValues.forEach((elementValue) => {
                    if (values.indexOf(elementValue) !== -1) {
                        $categoryElement.prop('checked', true);
                    }
                });
            });
        }

        // Označavanje otoka ili kopna
        if (self.$land.val().length) {
            const values = self.$land.val().split('|');

            $('.land').each((index, element) => {
                const $landElement = $(element);
                const elementValues = $landElement.val().split('|');

                elementValues.forEach((elementValue) => {
                    if (values.indexOf(elementValue) !== -1) {
                        $landElement.prop('checked', true);
                    }
                });
            });
        }

        // Označavanje broja soba
        if (self.$bedrooms.val() === '1') {
            $('#bedrooms1').addClass('has');
        } else if (self.$bedrooms.val() === '2') {
            $('#bedrooms2').addClass('has');
        } else if (self.$bedrooms.val() === '3') {
            $('#bedrooms3').addClass('has');
        } else if (self.$bedrooms.val() === '4') {
            $('#bedrooms4').addClass('has');
        }

        // Označavanje udaljenosti od plaže
        if (self.$beachDistance.val() === '50') {
            $('#beachDistance50').addClass('has');
        } else if (self.$beachDistance.val() === '100') {
            $('#beachDistance100').addClass('has');
        } else if (self.$beachDistance.val() === '200') {
            $('#beachDistance200').addClass('has');
        } else if (self.$beachDistance.val() === '500') {
            $('#beachDistance500').addClass('has');
        }

        // Označavanje vrste plaže
        if (self.$beachType.val() === 'sand') {
            $('#beachTypeSand').addClass('has');
        } else if (self.$beachType.val() === 'pebble') {
            $('#beachTypePebble').addClass('has');
        }

        // Označavanje WiFi-a
        if (self.$wifi.val() === '1') {
            $('#wifi').addClass('active');
        }

        // Označavanje klimatizacije
        if (self.$airConditioning.val() === '1') {
            $('#airCon').addClass('active');
        }

        // Označavanje kućnih ljubimaca
        if (self.$petsAllowed.val() === '1') {
            $('#pets').addClass('active');
        }

        // Označavanje pogleda na more
        if (self.$outerViewSea.val() === '1') {
            $('#seaView').addClass('active');
        }

        // Označavanje parkinga
        if (self.$parking.val() === '1') {
            $('#privateParking').addClass('active');
        }

        // Označavanje bazena
        if (self.$pool.val() === '1') {
            $('#pool').addClass('active');
        }

        // Označavanje veza za čamac
        if (self.$moor.val() === '1') {
            $('#moor').addClass('active');
        }

        // Označavanje doručka
        if (self.$food.val() === '1') {
            $('#food').addClass('active');
        }
    },
    setPriceValues() {
        const self = this;

        // Podešavanje max cijene
        if (Number(self.$priceTo.val()) === 200) {
            self.$priceTo.val('');
        }

        if (Number(self.$priceTo.val()) > 0 && self.$discounts.val().length > 0) {
            self.$discounts.val('');
        }
    },
};

function getAccommodationTypeValue() {
    const values = [];

    // za svaku vrstu smještaja koja je odabarana
    $('.accommodationType').each((index, element) => {
        const $accommodationTypeElement = $(element);

        if ($accommodationTypeElement.hasClass('has')) {
            values.push($accommodationTypeElement.data('value'));
        }
    });

    return values.join('|');
}

function initTotalResultCount(url) {
    const $filterForm = $('#filterForm');

    function getResultsCount() {
        filter.setPriceValues();
        showResultCountHelper(url);
    }

    $filterForm.on('change', ':input', debounce(getResultsCount, 100));
}

function showResultCountHelper(url) {
    const submitButton = document.querySelector('#save.filterSubmit');

    showResultCount()({
        url,
        filters: $('#filterForm').serializeArray(),
        submitButton,
        text: {
            default: submitButton.getAttribute('data-search-default-text'),
            noResults: submitButton.getAttribute('data-no-results-text'),
            foundResults: submitButton.getAttribute('data-results-found-text'),
        },
    });
}

export default filter;
